<template>
  <v-skeleton-loader
    v-if="!$_get(classData, 'id')"
    type="list-item-two-line, list-item-two-line, list-item-three-line, article"
  ></v-skeleton-loader>
  <div v-else-if="$_get(classData, 'type') === 'extraCurriculum'">
    <ExtraClassDetail />
  </div>
  <div v-else-if="$_get(classData, 'type') === 'coreCurriculum'">
    <div v-if="classData" class="pt-4" :class="{ 'px-4': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="classData.title"
        :headline="classData.title"
        :link="[
          { text: 'Danh sách lớp học', href: '../classes' },
          { text: classData.title, id: classData.id },
        ]"
      />

      <v-card outlined class="mt-6">
        <v-row class="d-flex">
          <v-col class="pa-8" cols="10">
            <div class="d-flex align-end justify-space-between">
              <div>
                <div>Lớp học</div>
                <h2>{{ classData.title }}</h2>
                <div>{{ classData.department ? classData.department.title : ''}}</div>
              </div>
              <div>
                <div>Chương trình đào tạo</div>
                <div class="font-weight-bold">{{ classData.division | getDivision }}</div>
              </div>
              <div>
                <div>Sĩ số</div>
                <div class="font-weight-bold">{{ getStudentCount }}</div>
              </div>

              <div>
                <div>Trạng thái</div>
                <v-chip
                  small
                  class="white--text"
                  v-if="classData.status"
                  :color="classData.status | classStatusColor"
                  label
                >
                  {{ classData.status | classStatus }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col class="pa-8 d-flex justify-end align-end" cols="2">
            <v-btn @click="detailState = !detailState" small color="primary" outlined>Hồ sơ chi tiết</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <ClassTabs class="mt-8" />
      <div class="text-center" v-if="$auth.policies['delete-class']">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa lớp học</v-btn>
      </div>
      <ClassDetailDialog @edit="updateDialogState = !updateDialogState" :classData="classData" :state="detailState" />

      <class-update-dialog :state="updateDialogState" :classData="classInfo"></class-update-dialog>
    </div>
    <h1 v-else-if="!$loading.active">Lớp học không tồn tại</h1>
  </div>
  <div v-else-if="$_get(classData, 'type') === 'administrative'">
    <div v-if="classData" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="classData.title"
        :headline="classData.title"
        :link="[
          { text: 'Danh sách lớp đầu vào', href: '../classes-administrative' },
          { text: classData.title, id: classData.id },
        ]"
      />

      <v-card outlined class="mt-6">
        <v-row class="d-flex">
          <v-col class="pa-6" cols="10">
            <div class="d-flex align-end justify-space-between">
              <div>
                <div>Bộ môn</div>
                <div class="font-weight-bold">
                  {{ classData.academicLevel.title }}
                </div>
              </div>
              <div>
                <div>Chương trình đào tạo</div>
                <div class="font-weight-bold">{{ classData.division | getDivision }}</div>
              </div>
              <div>
                <div>Sĩ số</div>
                <div class="font-weight-bold">{{ getStudentCount }}</div>
              </div>

              <div>
                <div>Trạng thái</div>
                <v-chip
                  small
                  class="white--text"
                  v-if="classData.status"
                  :color="classData.status | classStatusColor"
                  label
                >
                  {{ classData.status | classStatus }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col class="pa-6 d-flex justify-end align-end" cols="2">
            <v-btn @click="detailState = !detailState" small color="primary" outlined>Hồ sơ chi tiết</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <ClassAdministrativeTabs class="mt-8" />
      <div class="text-center" v-if="$auth.policies['delete-class'] && $_get(classData, 'type') === 'coreCurriculum'">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa lớp học</v-btn>
      </div>
      <div class="text-center" v-if="$auth.policies['delete-class'] && $_get(classData, 'type') === 'administrative'">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa lớp đầu vào</v-btn>
      </div>
      <class-update-dialog :state="updateDialogState" :classData="classInfo"></class-update-dialog>
    </div>
    <h1 v-else-if="!$loading.active">Lớp học không tồn tại</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get, map, chunk } from 'lodash-es'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import ClassUpdateDialog from '@/modules/class/ClassUpdateDialog.vue'
import ClassTabs from '@/modules/class/ClassTabs.vue'
import ClassDetailDialog from '@/modules/class/ClassDetailDialog.vue'
import ExtraClassDetail from '@/views/class/ExtraClassDetail.vue'
import { Teaching } from '@/plugins/api'
import ClassAdministrativeTabs from '../../modules/class-administrative/ClassAdministrativeTabs.vue'

export default {
  components: {
    Breadcrumbs,
    ClassUpdateDialog,
    ClassTabs,
    ClassAdministrativeTabs,
    ClassDetailDialog,
    ExtraClassDetail,
  },
  data() {
    return {
      selectedSlot: {},
      attendanceDialogState: false,
      updateDialogState: false,
      tab: null,
      detailState: false,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('classDetail', ['classData', 'slots', 'logs', 'attendances']),
    ...mapGetters('app', ['currentSchoolYear']),
    teacherNames() {
      if (!this.classData.teachers || this.classData.teachers.length === 0) {
        return ''
      }
      return this.classData.teachers.reduce((acc, cur, idx, arr) => {
        acc += cur.name
        if (idx !== arr.length - 1) acc += ','
        return acc
      }, '')
    },
    mentorNames() {
      if (!this.classData.mentors || this.classData.mentors.length === 0) {
        return ''
      }
      return this.classData.mentors.reduce((acc, cur, idx, arr) => {
        acc += cur.name
        if (idx !== arr.length - 1) acc += ','
        return acc
      }, '')
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg':
        case 'xl':
          return '436px'
        default:
          return '100%'
      }
    },
    teachers() {
      return []
    },
    students() {
      if (this.classData && this.classData.students) {
        const studentArray = this.classData.students.filter((s) => s.status === 'active')
        return studentArray
      }

      return []
    },
    classInfo() {
      return this.classData
    },
    classLogs() {
      return this.logs
    },
    classSlots() {
      return this.slots
    },
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg':
        case 'xl':
          return true
        default:
          return false
      }
    },
    getStudentCount() {
      return get(this.students, 'length', 0)
    },
    getCurrentSlot() {
      const currentSlot = this.slots.filter((slot) => {
        return new Date(slot.endTime).getTime() < new Date().getTime()
      })
      return currentSlot.length
    },
    getTotalSlot() {
      return get(this.slots, 'length', 0)
    },
    getPercentageAttendance() {
      const attendanceValues = Object.values(this.attendances)
      const attendanceNum = attendanceValues.filter(
        (attendance) => attendance.status === 'attendance' || attendance.status === 'late'
      )
      return Math.floor((attendanceNum.length / attendanceValues.length) * 100)
    },
  },
  methods: {
    ...mapActions('classDetail', ['initClass', 'fetchAttendances', 'resetClassData']),
    ...mapActions('class', ['removeClass']),

    checkAttendance(selected) {
      this.selectedSlot = selected
      this.attendanceDialogState = !this.attendanceDialogState
    },
    updateClass() {
      this.updateDialogState = !this.updateDialogState
    },
    remove() {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: `Bạn có chắc muốn xóa lớp ${
          get(this.classData, 'type') === 'coreCurriculum' ? 'học phần' : 'hành chính'
        } này? Bạn không thể hoàn tác hành động.`,
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          try {
            // if (this.classData.students && this.classData.students.length) {
            //   this.$alert.error('Không thể xóa lớp đang có Học viên')
            //   return
            // }

            this.$loading.active = true
            const teachings = await Teaching.fetch({
              class: this.classData.id,
            })
            const groups = chunk(teachings, 3)
            for (let subTeachings of groups) {
              await Promise.all(
                subTeachings.map(async (t) => {
                  return Teaching.remove(t.id)
                })
              )
            }

            await this.removeClass(this.classData.id)
            this.$alert.success('Xóa lớp học thành công!')
            this.$router.push(`/classes/`)
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  async created() {
    const classId = this.$route.params.id
    this.resetClassData()
    await this.initClass({ id: classId })
  },
  filters: {
    getMajorName(data) {
      return data ? data.title : ''
    },
    getRoomName(data) {
      return data ? data.title : ''
    },
    getTeacher(data) {
      if (!data || !data.length) return 'không có'
      else return map(data, 'name').join(', ')
    },
    getSchoolYear(schoolYear) {
      if (!schoolYear) return 'không có'
      else return schoolYear.name
    },
    getDivision(division) {
      if (!division) return 'không có'
      else return division.title
    },
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
